export const CUSTOM_CONTENT_RIGHTS = 'custom_content_rights';
export const STANDARD_CONTENT_RIGHTS = 'standard_content_rights';
